module.exports = __webpack_public_path__ + "52700ea08c34b20dfd196aebaf9728a8.png";